import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { AppSubBar, Card, EmptyState, LoadingState } from '@up2d8/ui';
import { TemporaryForm } from '../directory/temporary-form';
import { DeskShell } from './desk/desk-shell';
import { MessagesIcon } from './messages-icon';
import { NotificationBell } from './notification-bell';
import { renderAppTabLink, useAppTabs } from './app-tabs';
import { useMyTeam } from './use-my-team';
import { isAwaitingData } from '../../shared/query-state';

/**
 * `/app/team/tijdelijk`: een uitzendkracht of aannemer toevoegen, op de telefoon (Stap 31).
 *
 * De ingang staat in Mijn team, onder Teamleden. De teamleider kiest alleen uit de groepen die hij
 * beheert; de server dwingt dat af, dit scherm toont alleen die keuze.
 */
export function AppTeamTemporaryPage() {
  const { t } = useTranslation();
  const tabs = useAppTabs();
  const navigate = useNavigate();
  const team = useMyTeam();
  const groepen = (team.data?.teams ?? [])
    .filter((item) => item.kind === 'group')
    .map((item) => ({ id: item.teamId, name: item.label }));

  return (
    <DeskShell
      messages={<MessagesIcon />}
      bell={<NotificationBell />}
      tabs={tabs}
      activeKey="profile"
      renderLink={renderAppTabLink}
    >
      <div className="flex flex-col gap-element">
        <AppSubBar title={t('temporary.title')} onBack={() => void navigate({ to: '/app/team' })} />
        {/* Zonder teamrecht haalt de query niets op; `isPending` alleen bleef eeuwig laden (#14). */}
        {isAwaitingData(team) ? (
          <LoadingState rows={4} label={t('common.loading')} />
        ) : team.isError ? (
          <Card>
            <EmptyState title={t('temporary.failed')} />
          </Card>
        ) : !team.data ? (
          <Card data-testid="team-none">
            <EmptyState title={t('team.noTeamTitle')} description={t('team.noTeamHint')} />
          </Card>
        ) : (
          <Card>
            <TemporaryForm groups={groepen} />
          </Card>
        )}
      </div>
    </DeskShell>
  );
}
